<template>
  <div class="export-bill-container">
    <van-form
      @submit="onSubmit"
    >
      <van-field
        v-model="startBillMonth"
        readonly
        name="startBillMonth"
        label="账单开始月份"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择账单开始月份' }]"
        :disabled="disablePick"
        @click="onClickMonthField(true)"
      />
      <van-field
        v-model="endBillMonth"
        readonly
        name="endBillMonth"
        label="账单结束月份"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择账单结束月份' }]"
        :disabled="disablePick"
        @click="onClickMonthField(false)"
      />
      <van-popup
        v-model="showMonthPicker"
        position="bottom"
      >
        <van-datetime-picker
          type="year-month"
          :title="pickerTitle"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="handleBillMonthChange"
          @cancel="showMonthPicker = false"
        />
      </van-popup>
      <van-field
        v-model="email"
        name="email"
        label="接收邮件"
        placeholder="请输入接收邮箱"
        :rules="[{ required: true, message: '请输入接收邮箱' },{validator, message: '请输入正确的邮箱'}]"
        :disabled="disablePick"
      />

      <!-- 底部提示信息 -->
      <slot></slot>

      <van-button
        block
        class="submit"
        :disabled="submiting||disablePick"
        native-type="submit"
      >
        发送
      </van-button>
    </van-form>
  </div>
</template>

<script>
import Field from 'vant/lib/field';
import Form from 'vant/lib/form';
import Popup from 'vant/lib/popup';
import Picker from 'vant/lib/picker';
import Button from 'vant/lib/button';
import DatetimePicker from 'vant/lib/datetime-picker';

import 'vant/lib/field/style';
import 'vant/lib/form/style';
import 'vant/lib/popup/style';
import 'vant/lib/button/style';
import 'vant/lib/picker/style';
import 'vant/lib/datetime-picker/style';
import dayjs from 'dayjs';

export default {
  name: 'ExportBill',
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
  },
  props: {
    submiting: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: () => new Date(dayjs().subtract(10, 'year')),
    },
    maxDate: {
      type: Date,
      default: () => new Date(dayjs().add(10, 'year')),
    },
    disablePick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showMonthPicker: false,
      selectStartMonth: false,
      startBillMonth: '',
      endBillMonth: '',
      email: '',
      pickerTitle: '',
    };
  },
  methods: {
    validator(val) {
      return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val);
    },

    onClickMonthField(selectStartMonth) {
      if (this.disablePick) return;
      this.selectStartMonth = selectStartMonth;
      this.showMonthPicker = true;
      this.pickerTitle = selectStartMonth ? '账单开始月份' : '账单结束月份';
    },

    onSubmit(values) {
      this.$emit('on-submit', values);
    },

    handleBillMonthChange(time) {
      const month = dayjs(time).format('YYYYMM');
      if (this.selectStartMonth) {
        this.startBillMonth = month;
        if (this.startBillMonth > this.endBillMonth) {
          this.endBillMonth = this.startBillMonth;
        }
      } else {
        this.endBillMonth = month;
        if (this.startBillMonth > this.endBillMonth) {
          this.startBillMonth = this.endBillMonth;
        }
      }
      this.showMonthPicker = false;
    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme';

.export-bill-container {
  margin: 18px;

  .submit {
    background: $mt_yellow;
  }
}
</style>
